export default {
  id: 'portalContent',
  title: 'Portal content editor',
  note: 'The texts of this page itself. Editing them changes this screen.',
  texts: {
    'portalContent.title': 'Portal content',
    'portalContent.intro':
      'Every visible text in the portals has a default in the code. Changing one here stores an override; readers see it after a page refresh, with no deployment.',
    'portalContent.search.placeholder': 'Search by key or text…',
    'portalContent.search.label': 'Search',
    'portalContent.empty': 'Nothing matches that search.',
    'portalContent.changedBadge': 'changed',
    'portalContent.defaultLabel': 'Default:',
    'portalContent.action.save': 'Save',
    'portalContent.action.discard': 'Discard',
    'portalContent.action.reset': 'Reset to default',
    'portalContent.action.history': 'History',
    'portalContent.hint.lead': 'You can use',
    'portalContent.hint.placeholders': 'for values, and',
    'portalContent.hint.markdown': 'for emphasis and links. HTML is never rendered.',
    'portalContent.history.title': 'Change history',
    'portalContent.history.empty': 'No changes recorded for this text.',
    'portalContent.history.wasDefault': '(was the default)',
    'portalContent.history.resetToDefault': '(reset to the default)',
    'portalContent.history.close': 'Close',
    'portalContent.saved': 'Saved.',
    'portalContent.resetDone': 'Reset to default.',
    'portalContent.saveFailed': 'Could not save: {error}',
    'portalContent.groupCount': '{changed} of {total} changed',
  },
}
